import { useState } from 'react';
import CalendarWidget from '../components/widgets/CalendarWidget';

interface CalendarEvent {
  id: string;
  title: string;
  date: Date;
  description?: string;
  color?: string;
  startTime?: string;
  endTime?: string;
}

export default function CalendarDemo() {
  const [events, setEvents] = useState<CalendarEvent[]>([
    {
      id: '1',
      title: 'Reunião com Cliente',
      date: new Date(2026, 1, 10),
      description: 'Discussão sobre novo projeto',
      startTime: '10:00',
      endTime: '11:30',
      color: '#3b82f6',
    },
    {
      id: '2',
      title: 'Apresentação de Proposta',
      date: new Date(2026, 1, 15),
      description: 'Apresentar proposta comercial',
      startTime: '14:00',
      endTime: '15:00',
      color: '#10b981',
    },
    {
      id: '3',
      title: 'Treinamento Equipe',
      date: new Date(2026, 1, 20),
      description: 'Treinamento sobre novas funcionalidades',
      startTime: '09:00',
      endTime: '12:00',
      color: '#f59e0b',
    },
    {
      id: '4',
      title: 'Revisão de Sprint',
      date: new Date(2026, 1, 25),
      description: 'Revisão dos entregáveis da sprint',
      startTime: '16:00',
      endTime: '17:00',
      color: '#8b5cf6',
    },
  ]);

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        <div>
          <h1 className="text-4xl font-bold mb-2">Demonstração de Calendário</h1>
          <p className="text-muted-foreground">
            Sistema completo de calendário com gerenciamento de eventos e agenda
          </p>
        </div>

        <div className="space-y-6">
          <CalendarWidget
            title="Minha Agenda"
            events={events}
            onEventsChange={setEvents}
            viewMode="month"
            editable={true}
          />

          <div className="bg-card rounded-lg border p-6">
            <h2 className="text-xl font-semibold mb-4">Recursos do Calendário</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li className="flex items-start gap-2">
                <span className="text-primary">✓</span>
                <span><strong>Visualização Mensal:</strong> Veja todos os eventos do mês em uma grade intuitiva</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">✓</span>
                <span><strong>Adicionar Eventos:</strong> Clique em qualquer dia para criar um novo evento</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">✓</span>
                <span><strong>Editar/Deletar:</strong> Clique em eventos existentes para editar ou remover</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">✓</span>
                <span><strong>Horários:</strong> Defina horário de início e fim para cada evento</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">✓</span>
                <span><strong>Cores Personalizadas:</strong> Escolha cores para diferenciar tipos de eventos</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">✓</span>
                <span><strong>Navegação:</strong> Navegue entre meses com facilidade</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">✓</span>
                <span><strong>Destaque Hoje:</strong> O dia atual é destacado automaticamente</span>
              </li>
            </ul>
          </div>

          <div className="bg-card rounded-lg border p-6">
            <h2 className="text-xl font-semibold mb-4">Eventos Carregados</h2>
            <div className="space-y-2">
              {events.length === 0 ? (
                <p className="text-muted-foreground">Nenhum evento cadastrado</p>
              ) : (
                events.map((event) => (
                  <div
                    key={event.id}
                    className="flex items-center gap-3 p-3 rounded-lg border"
                  >
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: event.color }}
                    />
                    <div className="flex-1">
                      <div className="font-medium">{event.title}</div>
                      <div className="text-sm text-muted-foreground">
                        {new Date(event.date).toLocaleDateString('pt-BR')}
                        {event.startTime && ` às ${event.startTime}`}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
